const Experiment = ({
  experimentId = '',
  experimentName = '',
  variationId = '',
  variationName = '',
} = {}) => ({
  Experiment: {
    experimentId,
    experimentName,
    variationId,
    variationName,
  },
});

export default Experiment;
